import suppliers from './suppliers';
import users from './users';
import demands from './demands';
import purchaseOrders from './purchaseOrders';

export const supplierApi = suppliers;
export const userApi = users;
export const demandApi = demands;
export const purchaseOrdersApi = purchaseOrders;
